module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "ch03"
    }
  }, [_c('a', {
    attrs: {
      "id": "page21"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "chapterHead"
  }, [_c('h2', {
    staticClass: "chapterNumber"
  }, [_c('span', {
    staticClass: "xrefInternal"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/contents#ch_03"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("chapter 3")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "centerImage"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/21.jpg"
    }
  })]), _vm._v(" "), _c('h2', {
    staticClass: "chapterTitle"
  }, [_vm._v("THE PAST ENCROACHES")])]), _vm._v(" "), _c('div', {
    staticClass: "chapterBody"
  }, [_c('a', {
    attrs: {
      "id": "page22"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "chapterOpenerText"
  }, [_c('span', {
    staticClass: "chapterOpenerFirstWords"
  }, [_vm._v("“Get into the cab,")]), _vm._v(" we’re going to miss our flight,” Alondra said insistently.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Joaquin wanted to comply. The car was only inches away. He could be inside it in seconds. But he couldn’t move.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("It was the car: a 1990 Ford Taurus. Color: metallic green.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Fleetingly, he wondered why a taxi service would use such an old car. But this thought was quickly pushed aside by a crush of memories about a car just like this, and a trip so long ago.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("He could smell the upholstery, see the back of his father’s neck, and feel the ground bumping beneath him. The memory was so vivid it almost hurt. He could even remember how the volume knob felt on his beat-up Sony Walkman.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Joaquin, c’mon!”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Joaquin took a deep breath and reached for the door handle.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b8461084","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/chapter03.vue
// module id = 81
// module chunks = 0